import React, { FC } from 'react';
import style from './ContentLayout.module.scss';

interface IProps {
  contentLeft: React.ReactNode;
  contentRight: React.ReactNode;
}

export const ContentLayout: FC<IProps> = ({ contentLeft, contentRight }) => {
  return (
    <div className={style.content}>
      <div className={style.contentLeft}>{contentLeft}</div>
      <div className={style.contentRight}>{contentRight}</div>
    </div>
  );
};
